<template>
  <el-container v-title data-title="考勤机人脸图" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
                <el-breadcrumb-item>考勤机人脸图</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="detailCardPictureParam">查询</el-button>
                </el-form-item>
              </el-form>
              <el-form>
                <el-form-item>
                  <el-upload
                    ref="file-list-upload"
                    class="upload-demo"
                    drag
                    :on-change="handleOnChange"
                    :action="uploadUrl"
                    :auto-upload="false"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
                    <div class="el-upload__text">上传考勤机人脸图，单个小于10MB，单次小于1000MB</div>
                  </el-upload>
                  <el-button style="margin-left: 10px;" :loading="loading" type="primary" @click="uploadFiles">上传</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      searchForm: {
        schoolId: ''
      },
      uploadUrl: this.GLOBAL.host + '/user/uploadMeetingPic',
      fileList: [],
      loading: false
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    handleOnChange (file, fileList) {
      this.fileList = fileList
    },
    uploadFiles () {
      if (this.searchForm.schoolId === '' || this.fileList.length === 0) return
      let formData = new FormData()
      formData.append('schoolId', this.searchForm.schoolId)
      this.fileList.forEach(file => {
        formData.append('fileList', file.raw)
      })
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/user/uploadMeetingPic', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message.success(res.data.message)
            _this.fileList = []
            _this.$refs['file-list-upload'].clearFiles()
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/MeetingPicture.vue